
import { djangoApi } from "./auth";

const ROOT = "/api/beginner/admin";

const list = (path) => djangoApi.get(`${ROOT}/${path}/`);
const create = (path, payload) => djangoApi.post(`${ROOT}/${path}/`, payload);
const update = (path, id, payload) => djangoApi.patch(`${ROOT}/${path}/${id}/`, payload);
const remove = (path, id) => djangoApi.delete(`${ROOT}/${path}/${id}/`);

// Exam catalog
export const getBeginnerExamCatalog = () => list("exams");
export const createBeginnerExamCatalog = (payload) => create("exams", payload);
export const updateBeginnerExamCatalog = (id, payload) => update("exams", id, payload);
export const deleteBeginnerExamCatalog = (id) => remove("exams", id);

// Sections
export const getBeginnerSections = () => list("sections");
export const createBeginnerSection = (payload) => create("sections", payload);
export const updateBeginnerSection = (id, payload) => update("sections", id, payload);
export const deleteBeginnerSection = (id) => remove("sections", id);

// Practice sets
export const getBeginnerPracticeSets = () => list("practice-sets");
export const createBeginnerPracticeSet = (payload) => create("practice-sets", payload);
export const updateBeginnerPracticeSet = (id, payload) => update("practice-sets", id, payload);
export const deleteBeginnerPracticeSet = (id) => remove("practice-sets", id);

// Main exam access
export const getBeginnerExamAccess = () => list("main-exams");
export const createBeginnerExamAccess = (payload) => create("main-exams", payload);
export const updateBeginnerExamAccess = (id, payload) => update("main-exams", id, payload);
export const deleteBeginnerExamAccess = (id) => remove("main-exams", id);

// Subscriptions
export const getBeginnerSubscriptions = () => list("subscriptions");
export const updateBeginnerSubscription = (id, payload) => update("subscriptions", id, payload);

// Question PDF upload
export const uploadBeginnerQuestionPDF = (formData) =>
  djangoApi.post(`${ROOT}/question-pdfs/upload/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getBeginnerQuestionDocuments = () =>
  djangoApi.get(`${ROOT}/question-pdfs/`);

export const deleteBeginnerQuestionDocument = (id) =>
  djangoApi.delete(`${ROOT}/question-pdfs/${id}/`);

export const setBeginnerQuestionDocumentActive = (id, is_active) =>
  djangoApi.post(`${ROOT}/question-pdfs/${id}/activation/`, { is_active });

export const bulkDeleteBeginnerQuestionDocuments = (ids) =>
  djangoApi.post(`${ROOT}/question-pdfs/bulk-delete/`, { ids });

// Subscription plans
export const getBeginnerSubscriptionPlans = () => list("subscription-plans");
export const createBeginnerSubscriptionPlan = (payload) => create("subscription-plans", payload);
export const updateBeginnerSubscriptionPlan = (id, payload) => update("subscription-plans", id, payload);
export const deleteBeginnerSubscriptionPlan = (id) => remove("subscription-plans", id);

// Subscription payments
export const getBeginnerSubscriptionPayments = () => list("subscription-payments");
export const createBeginnerSubscription = (payload) => create("subscriptions", payload);

// Main-exam question bank
export const getBeginnerQuestions = (mainExamAccessId = "") => {
  const query = mainExamAccessId
    ? `?main_exam_access=${encodeURIComponent(mainExamAccessId)}`
    : "";

  return djangoApi.get(`${ROOT}/questions/${query}`);
};

export const updateBeginnerQuestion = (id, payload) =>
  update("questions", id, payload);

// Beginner main-exam results
export const getBeginnerMainExamResults = () => list("results");

export const updateBeginnerMainExamResult = (payload) =>
  djangoApi.patch(`${ROOT}/results/`, payload);
